import { colorMap } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { MuiBackdrop, MuiModal } from '../material-ui';
import { ModalContentProps } from './ModalContent.interface';

const useStyles = makeStyles(
  (muiTheme) => ({
    modal: {
      overflow: 'scroll',
      display: 'flex',
      alignItems: 'flex-start',
      padding: muiTheme.spacing(4),
      [muiTheme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    paper: {
      margin: 'auto',
      width: '100%',
      maxWidth: '100%',

      [muiTheme.breakpoints.down('sm')]: {
        margin: 0,
        width: '100%',
        height: '100%',
      },
    },
    backdrop: {
      backgroundColor: `${hexToRGBA(colorMap.black, 0.95)} !important`,
    },
  }),
  { name: 'GenModalContent' },
);

const ModalContent = ({
  className,
  title,
  description,
  children,
  toggleOpen,
  isOpen = false,
  keepMounted = false,
  ...restProps
}: PropsWithChildren<ModalContentProps>) => {
  const classes = useStyles();

  return (
    <MuiModal
      className={classes.modal}
      aria-labelledby={title}
      aria-describedby={description}
      open={isOpen}
      onClose={toggleOpen}
      BackdropComponent={MuiBackdrop}
      BackdropProps={{ className: classes.backdrop }}
      keepMounted={keepMounted}
      {...restProps}
    >
      <div className={clsx(classes.paper, className)}>{children}</div>
    </MuiModal>
  );
};

export default memo(ModalContent);
